module.exports = __webpack_public_path__ + "static/img/dq.2f80fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dq.png
// module id = bZaV
// module chunks = 0